import React from 'react'

import { TextInput, Button, Search as SearchIcon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, bool } from 'prop-types'

import ImageSearch from 'Pods/Shared/ImageSearch/ImageSearch'

import Suggestions from './Suggestions'
import useSearch from './useSearch'

function Search({ placeholder = '', locale = 'en', printReady = false }) {
  const {
    searchRef,
    searchedValue,
    submitting,
    suggestions,
    showSuggestions,
    actualPlaceholder,
    handleChange,
    handleKeyDown,
    handleSearchClick,
    handleKeywordSuggestionClick,
  } = useSearch({ placeholder, locale, printReady })

  const trailButton = (
    <Button
      size="medium"
      icon={
        submitting ? (
          <div className="new-search__loader-wrapper">
            <div className="cgt-spinner cgt-spinner--xsmall new-search__loader" />
          </div>
        ) : (
          <SearchIcon />
        )
      }
      variant="only-icon"
      onClick={handleSearchClick}
      style={{ position: 'absolute', right: '4px', top: '4px' }}
      aria-label="Search"
      data-track="search-submit"
      data-content-type="search"
    />
  )

  return (
    <div ref={searchRef} className="new-search__wrap new-search__wrap--with-image">
      <ImageSearch locale={locale} />
      <form
        className="new-search"
        onSubmit={(e) => {
          e.preventDefault()
          handleSearchClick()
        }}
        data-track="search-form"
        data-content-type="search"
      >
        <TextInput
          id="new-search-input"
          isPilot
          placeholder={actualPlaceholder}
          type="primary"
          inputType="text"
          trailButton={trailButton}
          handleChange={handleChange}
          onKeyDown={handleKeyDown}
          classNames="new-search__input"
          value={searchedValue}
          data-track="search-input"
          data-content-type="search"
        />
        {showSuggestions && suggestions?.keywords?.length ? (
          <Suggestions
            suggestions={suggestions}
            onKeywordClick={handleKeywordSuggestionClick}
          />
        ) : null}
      </form>
    </div>
  )
}

Search.propTypes = {
  placeholder: string,
  locale: string,
  printReady: bool,
}

export default Search
